var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_document-text",
    "data-name": "vuesax/outline/document-text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.114,
    fill: "#5256dd",
    height: 15.114,
    viewBox: "0 0 15.114 15.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.659,13.539H4.88C1.461,13.539,0,12.078,0,8.659V4.88C0,1.461,1.461,0,4.88,0H8.029A.476.476,0,0,1,8.5.472a.476.476,0,0,1-.472.472H4.88C1.977.945.945,1.977.945,4.88V8.659c0,2.9,1.033,3.936,3.936,3.936H8.659c2.9,0,3.936-1.033,3.936-3.936V5.51a.472.472,0,1,1,.945,0V8.659C13.539,12.078,12.078,13.539,8.659,13.539Z",
    transform: "translate(0.787 0.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.51,5.982H2.991C.838,5.982,0,5.144,0,2.99V.471A.467.467,0,0,1,.29.037a.476.476,0,0,1,.516.1L5.844,5.175a.473.473,0,0,1-.334.806ZM.945,1.611V2.99c0,1.625.422,2.047,2.047,2.047H4.37Z",
    transform: "translate(8.344 0.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.251.945H.472A.476.476,0,0,1,0,.472.476.476,0,0,1,.472,0H4.251a.476.476,0,0,1,.472.472A.476.476,0,0,1,4.251.945Z",
    transform: "translate(3.936 7.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.991.945H.472A.476.476,0,0,1,0,.472.476.476,0,0,1,.472,0H2.991a.476.476,0,0,1,.472.472A.476.476,0,0,1,2.991.945Z",
    transform: "translate(3.936 10.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H15.114V15.114H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDocument);
export default __webpack_public_path__ + "static/media/form_document.1d092b4d8e96c2dfdc6d36ee29851486.svg";
export { ForwardRef as ReactComponent };